import { join, map } from "ramda";
import * as React from "react";
import { connect } from "react-redux";
import { State } from "../../state";
import { getDebugState } from "../model/debug/selector";
import { AccountPresenter } from "../model/presenter/types";

export interface AccountMetadataProps {
  account: AccountPresenter;
  isDebug: boolean;
}

export const AccountMetadata: React.SFC<AccountMetadataProps> = ({
  account,
  isDebug
}) => {
  if (!isDebug) {
    return null;
  }

  return (
    <div>
      => ID: {account.id}; Type: {account.type}; Checked:{" "}
      {account.exceptionEligible.toString()}; Values ={" "}
      {join(", ", account.periodValues)}; Formula: {account.formula}; children =
      {map(
        (child: AccountPresenter) => (
          <div key={child.id}>
            • {child.id}: [{join(", ", child.periodValues)}]
          </div>
        ),
        account.children
      )}
    </div>
  );
};
const mapStateToProps = (state: State) => ({
  isDebug: getDebugState(state)
});

export default connect(mapStateToProps)(AccountMetadata);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/AccountMetadata.tsx